/**
 * @ngdoc Directive
 * @name vrm-input
 * @example
 *
 * <vrm-input />
 *
 */

(function() {
    'use strict';

    angular.module('vrm.components')
        .directive('vrmInput', vrmInput);

    /* @ngInject */
    function vrmInput($log) {

        var definition = {
            scope: {
                label: '@',
                name: '='
            },
            restrict: 'E',
            replace: true,
            transclude: true,
            require: '?ngModel',
            template: require('@/angular/modules/vrm-components/input/input.template.html'),
            link: link,
            compile: compile
        };

        return definition;

        function compile($element, $attr) {

            $log.warn('Compile');

            var $input = $element.find('input');

            angular.forEach({
                'name': $attr.name,
                'value': $attr.value,
                'disabled': $attr.disabled,
                'ng-value': $attr.ngValue,
                'ng-model': $attr.ngModel,
                'ng-disabled': $attr.ngDisabled,
                'ng-change': $attr.ngChange,
                'ng-required': $attr.ngRequired,
                'required': $attr.required
            }, function(value, name) {
                if (angular.isDefined(value)) {
                    $input.attr(name, value);
                }
            });

            return link;
        }

        /**
         * Link
         * @param $scope
         * @param $element
         * @param $attr
         */
        function link($scope, $element, $attr) {

            $log.info('link');

            $element.on('click', click);

            function click() {
                $log.info('toggle');
                $log.info($scope);
            }

            $scope.on('$destroy', function() {
                $element.off('click', click);
            });
        }
    }
})();
